export default __webpack_public_path__ + "static/simple-scatter-5fd5e4b67b236eb66eba351428977df1.png";